import fetch from '../../utils/fetch'

export function getUserParkingFeeList(params) {
    return fetch({
        url: '/api/ticket/userParkingFeeList',
        method: 'POST',
        data: params
    })
}
export function getParkinglotConfigInfo(params) {
    return fetch({
        url: `/api/ticket/getTicketConfig/`+params,
        method: 'get',
       
    })
}

//    // 获取停车场信息
//    getParkinglotConfigInfo(id) {
//     return axios.get(`${base.url}${base.path}/qetTicketConfig/parkinglotId=${id}` );
// },
